export async function getBase64(file: File): Promise<{ data: string }> {
    return new Promise((resolve, reject) => {
        let fileReader = new FileReader();
        fileReader.onload = function () {
            return resolve({ data: fileReader.result as string });
        }
        fileReader.readAsDataURL(file);
    })
}